<div class="vertical-page physician-entrepreneurs-page">
  <section class="hero-section">
    <div class="container">
      <div class="row align-items-center g-4 g-lg-5">
        <div class="col-lg-6 order-2 order-lg-1">
          <a routerLink="/communities" class="back-link mb-3">
            <mat-icon>arrow_back</mat-icon> Communities
          </a>
          <h1 class="headline mt-primary-text mb-3">Membership software for physician entrepreneur communities</h1>
          <p class="subheadline mt-primary-text mb-4">
            Manage members, events, directories, and private physician networks in one place—on the web and in the <a routerLink="/mobile" class="inline-link">shared MemberTrace mobile app</a> (one download for members, even across multiple MemberTrace communities).
          </p>
          <div class="cta-buttons">
            <button mat-flat-button color="primary" routerLink="/contact" [queryParams]="{ inquiryType: 'demo' }">Talk to our team</button>
            <button mat-stroked-button color="primary" routerLink="/pricing">See pricing</button>
          </div>
        </div>
        <div class="col-lg-6 order-1 order-lg-2">
          <div class="hero-image-wrap">
            <img src="/img/physicians-hero.webp" alt="Physician entrepreneur community membership management" class="hero-image" />
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="features-section py-5">
    <div class="container">
      <h2 class="section-title text-center mb-3">Everything physician entrepreneur communities need to connect and grow</h2>
      <p class="section-intro text-center mb-5">MemberTrace helps physician entrepreneur groups manage the relationships, events, and structure that keep communities active and valuable over time.</p>
      <div class="row g-4">
        <div class="col-md-6 col-lg-4" *ngFor="let feature of features">
          <div class="feature-item">
            <mat-icon color="primary" class="feature-icon">{{ feature.icon }}</mat-icon>
            <h3 class="feature-title">{{ feature.title }}</h3>
            <p class="feature-description">{{ feature.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="example-communities-section py-5">
    <div class="container">
      <h2 class="section-title text-center mb-3">Perfect for physician communities like these</h2>
      <p class="section-intro text-center mb-5">MemberTrace supports physician-led communities built around entrepreneurship, networking, investing, and growth.</p>
      <div class="row g-4">
        <div class="col-md-6 col-lg-3" *ngFor="let community of exampleCommunities">
          <div class="community-type-card">
            <h3 class="community-type-title">{{ community.title }}</h3>
            <p class="community-type-desc">{{ community.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="structured-section py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-9">
          <h2 class="section-title text-center mb-3">Built for structured communities, not just chat spaces</h2>
          <p class="section-intro text-center mb-5">Physician entrepreneur groups need more than discussion threads. MemberTrace helps community leaders manage membership, events, payments, directories, and growth in one place.</p>
          <ul class="structured-list">
            <li *ngFor="let point of structuredPoints">
              <strong class="structured-point-title">{{ point.title }}</strong>
              <span class="structured-point-desc">{{ point.description }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="cta-section py-5">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <h2 class="cta-title mb-3">Build a stronger physician entrepreneur community</h2>
          <p class="cta-subtitle mb-4">Whether you're organizing an existing physician network or launching a new entrepreneur community, MemberTrace gives you the tools to bring members together and grow with structure.</p>
          <div class="cta-buttons d-flex flex-wrap gap-3 justify-content-center">
            <button mat-flat-button color="primary" routerLink="/contact">Talk to our team</button>
            <button mat-stroked-button color="primary" routerLink="/start-a-community">Start your community</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
